import {selector} from './selector';
import * as events from "./events";

const PageOrderTag = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function initEvents() {
        //$(document).on('submit', selector.checkoutForm, events.submitForm);
        $(document).on('click', selector.btn.addVehicle, events.addVehicleInput);
        $(document).on('click', selector.btn.removeVehicle, events.removeVehicleInput);
        $(document).on('change', selector.deliveryMethod, events.toggleDeliveryMethod);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageOrderTag};